// extracted by mini-css-extract-plugin
export default {"setup_class_routine":"setup-class-routine_js_setup_class_routine__KBQ5b","title":"setup-class-routine_js_title__7Iz7X"};